export const blogPosts = [
  {
    title: 'AI and the Nietzschean Void',
    slug: 'ai-void',
    date: '2026-03-20',
    excerpt: 'Fall in the void.',
    url: '/blog/ai-void.md',
    pinned: true,
    tag: 'human',
  },
  {
    title: 'Direction and Intentionality',
    slug: 'intention',
    date: '2026-02-06',
    excerpt: 'The difference in speed and velocity.',
    url: '/blog/intention.md',
    tag: 'human',
  },
  {
    title: 'A Short Collection of Opening Lines',
    slug: 'book-openings',
    date: '2026-02-14',
    excerpt: 'Some lines. Will add more TBD.',
    url: '/blog/book-openings.md',
    tag: 'human',
  },
  {
    title: 'The Spectacle of Intelligence',
    slug: 'spectacle',
    date: '2026-01-15',
    excerpt: 'We live in a society.',
    url: '/blog/spectacle.md',
    pinned: true,
    tag: 'human',
  },
  {
    title: 'Projecting Ideology: A Mathematical Philosophy of Politics',
    slug: 'philosophy-as-projection',
    date: '2025-03-23',
    excerpt: 'Mathematical universe.',
    url: '/blog/philosophy-as-projection.md',
    tag: 'ai-slop',
  },
  {
    title: 'Choosing the Wrong Life on Purpose',
    slug: 'wrong-life',
    date: '2025-08-15',
    excerpt: 'Stories of crises.',
    url: '/blog/wrong-life.md',
    tag: 'human',
  },
  {
    title: 'Capitalist Melancholia',
    slug: 'melancholia',
    date: '2025-07-14',
    excerpt: 'Read this article',
    url: '/blog/melancholia.md',
    tag: 'human',
  },
  {
    title: 'Whiskey Storms and Silence',
    slug: 'whisky',
    date: '2025-03-23',
    excerpt: 'Whiskymärken från hela världen.',
    url: '/blog/whisky.md',
    tag: 'ai-slop',
  },
  {
    title: 'The New Surrender: Notes from a Life Without Appeal',
    slug: 'surrender',
    date: '2025-03-23',
    excerpt: 'Read this article',
    url: '/blog/surrender.md',
    tag: 'human',
  },
  {
    title: 'MLArtifactFS: Lazy-Loading ML Models with FUSE',
    slug: 'ml-containers',
    date: '2026-04-04',
    excerpt: 'MLArtifactFS',
    url: '/blog/ml-containers.md',
    tag: 'human',
  },
  {
    title: 'Long-Term Engagement as a Philosophical Problem',
    slug: 'engagement',
    date: '2026-02-21',
    excerpt: 'Stable Marriage.',
    url: '/blog/engagement.md',
    tag: 'human',
  },
];



export const blogGraph = {
  nodes: blogPosts.map(post => ({
    id: post.slug,
    title: post.title,
  })),
  links: [
    { source: 'philosophy-as-projection', target: 'spectacle' },
    { source: 'philosophy-as-projection', target: 'ai-void' },
    { source: 'spectacle', target: 'ai-void' },

    { source: 'wrong-life', target: 'ai-void' },
    { source: 'wrong-life', target: 'surrender' },
    { source: 'engagement', target: 'wrong-life' },

    { source: 'surrender', target: 'melancholia' },
  ]
};
